<template>
    <!--Waiting List Settings Page-->
    <div class="waiting-list-settings">
        <h3>{{ $t("waitingListSettings.title") }}</h3>
        <div class="section-wrap">
            <div v-if="!loading">
                <h5>{{ $t("waitingListSettings.waitlist") }}</h5>
                <!--Subscribed-->
                <div class="wlist-subscription-renewal"
                    v-if="waitingListSettings.active && statusSubscription === 'subscribed'">
                    <h5>{{ $t("waitingListSettings.autoRenewal") }}</h5>
                    <p>
                        You are currently subscribed to the Waitlist feature. This subscription renews automatically
                        each {{ waitingListSettings.billing_cycle === "yearly" ? "year" : "" }} on your signup
                        anniversary.
                    </p>
                    <p>
                        {{ $t("waitingListSettings.nextRenewalDate") }}:
                        {{ getFormattedDate(waitingListSettings.subscription_expires_on, "dddd, MMMM D, YYYY") }}.
                    </p>
                    <p>
                        After your first month, the subscription will renew at the regular price of {{ profileCurrency
                        }}{{ enrollmentCost }} {{ waitingListSettings.billing_cycle === "yearly" ? "annually" : "" }},
                        unless you cancel before the renewal date.
                    </p>
                </div>
                <!--Trial-->
                <div class="wlist-subscription-renewal"
                    v-if="waitingListSettings.active && statusSubscription === 'trial'">
                    <h5>{{ $t("waitingListSettings.autoRenewal") }}</h5>
                    <p>Your Free Trial of the Waitlist Feature</p>
                    <p>
                        {{ $t("waitingListSettings.trialEndDate") }}:
                        {{ getFormattedDate(waitingListSettings.endTrialDate, "dddd, MMMM D, YYYY") }}.
                    </p>
                    <p>
                        Once your free trial ends, the subscription will begin at the regular price of
                        {{ profileCurrency }}{{ enrollmentCost }} annually, renewing each year on your signup
                        anniversary unless canceled before the renewal date.
                    </p>
                </div>
                <!--Unsubscribed-->
                <div class="wlist-subscription-renewal" v-if="!waitingListSettings.active">
                    <h5>Your Waitlist Subscription</h5>
                    <p>You have successfully canceled your subscription.</p>
                    <p>
                        You will continue to have access to the Waitlist feature until your paid period ends on
                        {{ getFormattedDate(waitingListSettings.subscription_expires_on, "dddd, MMMM D, YYYY") }}.
                    </p>
                </div>
                <div class="cancel-wlist-subscription">
                    <h5 v-if="waitingListSettings.active">
                        <span v-if="statusSubscription === 'trial'">
                            {{ $t("waitingListSettings.cancelWaitlistTrial") }}
                        </span>
                        <span v-if="statusSubscription === 'subscribed'">
                            {{ $t("waitingListSettings.cancelWaitlist") }}
                        </span>
                    </h5>
                    <p v-if="waitingListSettings.active">
                        <span v-if="statusSubscription === 'trial'">
                            {{ $t("waitingListSettings.cancelWaitlistMessageTrial") }}
                        </span>
                        <span v-if="statusSubscription === 'subscribed'">
                            {{ $t("waitingListSettings.cancelWaitlistMessage") }}
                        </span>
                    </p>
                    <div class="next-step">
                        <router-link class="primary-btn extra-small mobile"
                            :to="{ path: '/app/waiting-list/dashboard' }">
                            {{ $t("general.goBack") }}
                        </router-link>
                        <button v-if="waitingListSettings.active"
                            class="cancel-subscription primary-btn extra-small mobile" type="button" data-bs-toggle="modal"
                            data-bs-target="#cancelSubscription" :class="loading ? 'disabled-button' : ''"
                            :disabled="loading">
                            {{ statusSubscription === "trial" ? "Cancel Trial" : "Cancel Subscription" }}
                        </button>
                        <button v-if="!waitingListSettings.active" @click="createWaitingListBraintreeSubscription"
                            class="primary-btn extra-small mobile" type="button"
                            :class="loading ? 'disabled-button' : ''" :disabled="loading">
                            Start Subscription
                        </button>
                    </div>
                </div>
            </div>
            <main-loader v-if="loading"></main-loader>
        </div>
        <waiting-list-modal title="Cancel Subscription" p1="Are you sure you want to cancel your Waitlist subscription?"
            id="cancelSubscription" buttonText="Yes" buttonText2="No" :cancelSubscription="true"
            @cancel-subscription="cancelWaitingListBraintreeSubscription">
        </waiting-list-modal>
    </div>
</template>

<script>
import api from "../../../services/apiEndpoints";
import messages from "../../../services/messages";
import WaitingListModal from "./parts/WaitingListModal.vue";
import moment from "moment";
import MainLoader from "../general-components/MainLoader.vue";
import store from "../../../services/vuex";
import eventBus from "../../../services/eventBus";

export default {
    data() {
        return {
            waitingListSettings: {},
            loading: false,
            loadedCurrency: false,
            profile: {},
            profileCurrency: "$",
            statusSubscription: "",
            endTrialDate: "",
        };
    },
    computed: {
        adminDetails: {
            get: function () {
                return this.$store.state.adminDetails;
            },
            set: function (value) {
                this.$store.commit("setAdminDetails", value);
            },
        },
    },
    mounted() {
        this.enrollmentCost = import.meta.env["VITE_ENROLLMENT_COST_YEARLY"];

        if (this.adminDetails && this.adminDetails.profile) {
            this.getStylistProfile();
        }

        eventBus.on("admin_details_loaded", () => {
            this.getStylistProfile();
        });

        this.getWaitingListSubscriptionAndSettings();
    },
    components: {
        WaitingListModal,
        MainLoader,
    },
    methods: {
        createWaitingListBraintreeSubscription() {
            this.loading = true;

            let data = {
                users_number: 1,
                app_id: this.generalOptions.app_id,
            };

            this.$http.post(api.actions.save_waiting_list_braintree_subscription, data).then((response) => {
                this.loading = false;

                if (response.data.error == true) {
                    return;
                }

                messages.successMessage(messages.GLOBAL_MESSAGES.WAITING_LIST_SUBSCRIPTION_CREATED);
                this.getWaitingListSubscriptionAndSettings();
                eventBus.emit("reload_user_details");
            });
            return;
        },
        cancelWaitingListBraintreeSubscription() {
            this.loading = true;
            this.$http.post(api.actions.cancel_waiting_list_braintree_subscription).then((response) => {
                if (response.data.error == true) {
                    return;
                }

                messages.successMessage(messages.GLOBAL_MESSAGES.WAITING_LIST_SUBSCRIPTION_CANCELED);
                this.getWaitingListSubscriptionAndSettings();
                this.loading = false;
                eventBus.emit("reload_user_details");
            });
            return;
        },
        getWaitingListSubscriptionAndSettings() {
            this.loading = true;
            this.$http.get(api.actions.get_waiting_list_subscription_and_settings).then((response) => {
                if (response.data.error == true) {
                    return;
                }

                this.waitingListSettings = response.data.waitlist_subscription_and_settings;
                this.isTrialPeriod(this.waitingListSettings.created_at);
                this.getTrialEndDate(this.waitingListSettings.created_at);
                this.loading = false;
            });
            return;
        },
        getFormattedDate(date, format) {
            return moment(date).format(format);
        },
        getStylistProfile() {
            this.profile = this.adminDetails.profile;
            this.loadedCurrency = true;
        },
        isTrialPeriod(dateString) {
            const createdAt = moment(dateString, "YYYY-MM-DD HH:mm:ss");
            const currentDate = moment();
            const diffInDays = currentDate.diff(createdAt, "days");

            if (diffInDays <= 30) {
                this.statusSubscription = "trial";
            } else {
                this.statusSubscription = "subscribed";
            }
        },
        getTrialEndDate(dateString) {
            this.endTrialDate = moment(dateString, "YYYY-MM-DD HH:mm:ss").add(30, "days").format("YYYY-MM-DD");
        },
    },
};
</script>
